import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0A0F1E] border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-white font-bold text-xl">Los Propios Tech</h3>
            <p className="text-white/60 text-sm leading-relaxed">
              Expertos digitales que te resuelven la vida. Tecnología hecha por venezolanos, 
              para venezolanos. Simple, confiable y siempre disponible.
            </p>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="#privacy" 
                  className="text-white/60 hover:text-[#25D366] transition-colors duration-300 text-sm"
                >
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a 
                  href="#terms" 
                  className="text-white/60 hover:text-[#25D366] transition-colors duration-300 text-sm"
                >
                  Términos de Servicio
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-white/60 text-sm group">
                <MapPin className="h-5 w-5 text-[#25D366] mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span>Cr 3 con Calle C, Casa Nro 90-83, Urb La Morenera, Los Rastrojos, Lara, ZP 3023</span>
              </li>
              <li className="flex items-center gap-3 text-white/60 text-sm group">
                <Mail className="h-5 w-5 text-[#25D366] flex-shrink-0 group-hover:scale-110 transition-transform" />
                <a 
                  href="mailto:hola@lospropios.tech" 
                  className="hover:text-[#25D366] transition-colors"
                >
                  hola@lospropios.tech
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/60 text-sm group">
                <Phone className="h-5 w-5 text-[#25D366] flex-shrink-0 group-hover:scale-110 transition-transform" />
                <a 
                  href="tel:+584225997721" 
                  className="hover:text-[#25D366] transition-colors"
                >
                  +58 422 599 7721
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} Los Propios Tech. Todos los derechos reservados. Marca comercial operada por EIBAR JESUS HERNANDEZ ALVARADO.
            </p>
            <p className="text-white/40 text-sm">
              Hecho con 💚 en Venezuela
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
